import "./namespace.js";
import "#/legacy/namespaces.js";

DoctorFinder.Helpers.specialties = function (skills) {
  return skills.map(this.specialtyLink).join(", ");
};

DoctorFinder.Helpers.specialtyLink = (skill) => {
  if (skill.selected || !skill.parameterize) {
    return skill.name;
  } else {
    return `<a href='?${skill.filter}=${skill.parameterize}' data-doctor-finder-behaviour='add-filters' class='covert'>${skill.name}</a>`;
  }
};
